import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useAuth } from 'hooks/UseAuth'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useRootStore } from 'stores/RootStore'
import { setDatadogUser, setIsAutopilotInStorage } from 'datadogRum'

export const DatadogUserInfo = observer(() => {
  const auth = useAuth()
  const workspace = useCurrentWorkspace()
  const isAutopilot = workspace?.is_virtual_marketer
  const { tierUsageStore } = useRootStore()
  const plan = tierUsageStore.currentSubscription?.plan

  useEffect(() => {
    if (workspace) {
      setIsAutopilotInStorage(!!isAutopilot)
    }
  }, [workspace, isAutopilot])

  useEffect(() => {
    if (auth?.id && auth?.email) {
      setDatadogUser({
        id: auth.id,
        email: auth.email,
        isAutopilot: !!isAutopilot,
        plan,
      })
    }
  }, [auth?.id, auth?.email, isAutopilot, plan])

  return null
})
